import React from "react"
import Image from "next/image"
import media from "styled-media-query"
import styled from "styled-components"
import IconYellow from "@/common/assets/image/lucky-bag-2023/icon-yellow.png"

import { theme } from "./mixin"

const NavItem = ({
  text,
  connect,
  onClick,
  showDisconnect,
  onDisconnect,
  to,
  blank,
  id
}) => {
  return (
    <>
      {to ? (
        <a
          href={to}
          target={blank ? "blank" : "_self"}
          onClick={onClick}
          id={id}
        >
          <Wrapper className={connect ? "connect" : ""}>
            {/* <Image
            src={IconYellow}
            alt="icon-yellow.png"
            width={34}
            height={34}
          /> */}
            {text}
          </Wrapper>
        </a>
      ) : (
        <Wrapper className={connect ? "connect" : ""} onClick={onClick}>
          <Image
            src={IconYellow}
            alt="icon-yellow.png"
            width={34}
            height={34}
            style={{
              maxWidth: "100%",
              height: "auto"
            }}
          />
          {text}
          {showDisconnect && onDisconnect && (
            <div
              style={{ cursor: "pointer", marginLeft: 10, marginTop: 5 }}
              onClick={onDisconnect}
            >
              <Image
                src="/icon_disconnect.png"
                alt="disconnect"
                width={25}
                height={25}
                style={{
                  maxWidth: "100%",
                  height: "auto"
                }}
              />
            </div>
          )}
        </Wrapper>
      )}
    </>
  )
}

export default NavItem

const Wrapper = styled.div`
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.4;
  padding: 0 24px;
  height: 70px;
  transition: all 0.3s;
  cursor: pointer;
  color: ${theme.secondary};
  font-family: ${theme.titleFonts};
  :hover {
    color: ${theme.CTAcolor};
  }

  ${media.lessThan("1550px")`
    padding: 32px 24px;
    /* font-size: 16px; */
  `}
  ${media.lessThan("1440px")`
    padding: 12px 16px;
    font-size: 16px;
  `}
  &.connect {
    background-color: ${theme.red};
    margin-left: 24px;
  }
`
